import Link from "@mui/material/Link";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { ProductRow } from "../types";
import { useMemo } from "react";

export const useGetProductColumns = () => {
  const navigate = useNavigate();

  const productColumns = useMemo<GridColDef<ProductRow[][number]>[]>(() => {
    return [
      {
        field: "product",
        headerName: "Product",
        flex: 1,
        renderCell: (params) => {
          const productLocation = "/catalog/product/product/" + params.id;

          return (
            <Link
              href={productLocation}
              underline="none"
              onClick={(e) => {
                e.preventDefault();
                navigate(productLocation);
              }}
            >
              {params.value}
            </Link>
          );
        },
      },
      {
        field: "category",
        headerName: "Category",
        flex: 1,
      },
      {
        field: "vendor",
        headerName: "Vendor",
        flex: 1,
        renderCell: (params) => {
          const vendorLocation =
            "/catalog/product/vendor/" + params.row.vendorId;

          return (
            <Link
              href={vendorLocation}
              underline="none"
              onClick={(e) => {
                e.preventDefault();
                navigate(vendorLocation);
              }}
            >
              {params.value}
            </Link>
          );
        },
      },
      {
        field: "attributes",
        headerName: "Attributes",
        flex: 1,
      },
    ];
  }, [navigate]);

  return {
    productColumns,
  };
};
